function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 283.5 283.5"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M150.5 233.5l-10-10.1-20 20-20-20-10 10.1 20 20-20 19.9 10 10.1 20-20 20 20 10-10.1-20-19.9z"
}), /*#__PURE__*/React.createElement("path", {
  d: "M62.6 255.1c-7.2 0-13.1-5.6-13.1-12.5v-37.2h71.4V28.2H28.7v70.9H0v106.3h21.4v37.2c0 22.4 18.5 40.6 41.2 40.6h8.3v-28.1h-8.3zM57.1 56.6h35.4V177H78.4V99H57.1V56.6zM29.3 177v-49.6H50V177H29.3zM208.9 117.3l-74.6 59.3 17.9 21.9 7.1-5.6V234h35.5v13.2c-.1 4.6-4 8.3-8.6 8.2h-16.1v28.1h16.1c20.3 0 36.7-16.3 36.7-36.3V234h35.5v-41.2l7.1 5.7 17.9-21.9-74.5-59.3zm21.2 88.3h-42.5v-35.3l21.2-16.9 21.2 16.9.1 35.3z"
})));